<div class="loading" *ngIf="!allSet">
    <img
        src="./assets/images/init-loading.gif"
        alt="loading sell process"
        class="loading-image"
    />
</div>
<router-outlet *ngIf="allSet"></router-outlet>
